/**
 * 门户文本默认配置数据
 */
export const home = [
  {},
  {
    styleId: 2,
    iframeUrl: "https://vr.chaoxing.com/#/showCustomerSpace?id=MjY2OTE=&&type=cus&isPt&specialSwipe2"
  },
  {
    styleId: 3,
    iframeUrl: "https://vr.chaoxing.com/#/showCustomerSpace?id=MjcwMTg=&&type=cus&isPt&specialSwipe1"
  },
  {
    styleId: 4,
    iframeUrl: "https://vr.chaoxing.com/#/showCustomerSpace?id=MjY4NTQ=&&type=cus&isPt&specialSwipe2"
  }
]

/**
 * 大屏文本默认配置数据
 */
export const bs = [{}]

/**
 * app文本默认配置数据
 */
export const appHome = [
  {},
  {
    styleId: 2,
    iframeUrl: "https://vr.chaoxing.com/#/showCustomerSpace?id=MjY2OTE=&&type=cus&isPt&specialSwipe2"
  },
  {
    styleId: 3,
    iframeUrl: "https://vr.chaoxing.com/#/showCustomerSpace?id=MjcwMTg=&&type=cus&isPt&specialSwipe1"
  },
  {
    styleId: 4,
    iframeUrl: "https://vr.chaoxing.com/#/showCustomerSpace?id=MjY4NTQ=&&type=cus&isPt&specialSwipe2"
  }
]
